import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import process from 'process';
const root = ReactDOM.createRoot(document.getElementById('root'));
// Polyfill for process
if (typeof process === 'undefined') {
  global.process = {
    env: {
      NODE_ENV: 'development', // or 'production'
    },
  };
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
